jQuery(document).ready(function ($) {

    /* Slick Slider */
    $('.ts-wrapper').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: '0px',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    centerMode: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.ts-wrapper').on('setPosition', function (event, slick) {
        slick.$slides.css(
            'height',
            slick.$slideTrack.height() + 'px'
        );
    });

    /* Donation Buttons */

    const container = document.querySelector('.donation-box');

    if (container) {

        const buttons = container.querySelectorAll('.amount-btn');
        const input = container.querySelector('.custom-amount');

        buttons.forEach(btn => {

            btn.addEventListener('click', function () {

                buttons.forEach(b =>
                    b.classList.remove('active')
                );

                this.classList.add('active');

                if (this.classList.contains('other-btn')) {

                    input.style.display = 'block';
                    input.value = '';
                    input.focus();

                } else {

                    input.style.display = 'none';
                    input.value = this.dataset.value;

                }

            });

        });

    }

    /* Tabs */

    const wrapper = document.querySelector(".tab-wrapper");

    if (wrapper) {

        const buttons = wrapper.querySelectorAll(".tab-btn");
        const panels = wrapper.querySelectorAll(".tab-panel");

        buttons.forEach(button => {

            button.addEventListener("click", function () {

                const tabId = this.dataset.tab;

                buttons.forEach(btn =>
                    btn.classList.remove("active")
                );

                panels.forEach(panel =>
                    panel.classList.remove("active")
                );

                this.classList.add("active");

                wrapper
                    .querySelector("#" + tabId)
                    .classList.add("active");

            });

        });

    }



    //     function updateAccordion() {
    // document.querySelectorAll('.zp-accordion').forEach(function (accordion) {
    //     if (!accordion.dataset.processed) {
    //     const header = accordion.querySelector('.zp-accordion-header');
    //     const content = accordion.querySelector('.zps-content');
    
    //     if (header && content) {
    //         const headerText = header.textContent;
    //         header.remove();
    
    //         const h3 = document.createElement('h3');
    //         h3.textContent = headerText;
    
    //         content.prepend(h3);
    
    //         accordion.dataset.processed = "true"; // prevent duplicate processing
    //     }
    //     }
    // });
    // }
    updateAccordion();
    const observer = new MutationObserver(function () {
    updateAccordion();
    });
    
    observer.observe(document.body, {
    childList: true,
    subtree: true
    });


     function desktopMenuHover() {

    if (window.innerWidth > 990) {

      const menus = document.querySelectorAll('header-menu details');

      menus.forEach(function (menu) {

        menu.addEventListener('mouseenter', function () {
          menu.setAttribute('open', true);
        });

        menu.addEventListener('mouseleave', function () {
          menu.removeAttribute('open');
        });

      });

    }

  }

  desktopMenuHover();






  
});


document.addEventListener("DOMContentLoaded", function () {

    const counters = document.querySelectorAll(".counter");

    const startCounter = (counter) => {

        const target = parseInt(counter.getAttribute("data-count"));
        const prefix = counter.getAttribute("data-prefix") || "";
        const suffix = counter.getAttribute("data-suffix") || "";

        let count = 0;
        const speed = target / 100;

        const updateCounter = () => {

            count += speed;

            if (count < target) {

                let displayValue = Math.floor(count);

                if (target >= 1000000) {
                    displayValue = (displayValue / 1000000).toFixed(1) + "M";
                } else {
                    displayValue = displayValue.toLocaleString();
                }

                counter.innerHTML = prefix + displayValue + suffix;

                requestAnimationFrame(updateCounter);

            } else {

                let finalValue;

                if (target >= 1000000) {
                    finalValue = (target / 1000000).toFixed(1) + "M";
                } else {
                    finalValue = target.toLocaleString();
                }

                counter.innerHTML = prefix + finalValue + suffix;
            }
        };

        updateCounter();
    };

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                startCounter(entry.target);

                observer.unobserve(entry.target);
            }
        });

    }, {
        threshold: 0.5
    });

    counters.forEach(counter => {
        observer.observe(counter);
    });

});



/* // Donation Styles page js// */
document.addEventListener('click', function(e){

    const btn = e.target.closest('.tab-btn');

    if(!btn) return;

    e.preventDefault();

    const target = document.getElementById(btn.dataset.target);

    if(!target) return;

    document.querySelectorAll('.tab-btn').forEach(function(item){
        item.classList.remove('active');
    });

    btn.classList.add('active');

    target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });

});